import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { CustomPagination } from 'components/purchase/CustomPagination'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import { NotificationsTable } from './NotificationsTable'
import {
  NotificationFiltersType,
  NotificationsFilters,
} from './NotificationsFilters'
import { useQueryState } from 'react-router-use-location-state'
import { useNotificationsQuery } from 'services/notification'
import { EmptyTableState } from 'components/purchase/EmptyTableState'
import { useTranslation } from 'react-i18next'

const breadCrumbItems = [
  {
    id: 'home',
    title: 'Ana səhifə',
    path: '/',
  },
  {
    id: 'notifications',
    title: 'Bildirişlər',
  },
]

export const Notifications: React.FC = () => {
  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10
  const [filters, setFilters] = useState<NotificationFiltersType>({
    orgName: '',
    from: '',
    until: '',
  })
  const { t } = useTranslation()

  const args = {
    page,
    size: rowsPerPage,
    orgName: filters.orgName,
    from: filters.from,
    until: filters.until,
  } as const

  const { data: notifications } = useNotificationsQuery(args, {
    refetchOnMountOrArgChange: true,
  })

  const handleSearch = (values: NotificationFiltersType) => {
    setFilters({ ...filters, ...values })
  }

  return (
    <PurchaseLayout breadCrumbItems={breadCrumbItems}>
      <Typography variant="h5">{t('notifications')}</Typography>
      <NotificationsFilters handleSearch={handleSearch} />
      {notifications?.items && notifications?.items.length !== 0 ? (
        <NotificationsTable data={notifications?.items!} />
      ) : (
        <EmptyTableState />
      )}
      {notifications?.info.totalRows !== 0 && (
        <CustomPagination
          total={notifications?.info.totalRows!}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PurchaseLayout>
  )
}
